import type { RuntimeConfig } from 'types';
import type { CampaignPackageToDetails } from 'modules/campaigns/components/campaign-package/types';

export function mapConfigValuesToCampaignPackageDetails(
  values: RuntimeConfig
): CampaignPackageToDetails {
  return {
    l: {
      promotionBudget: values.ccmCampaignPackageLBudget ?? 20000,
      numOutfits: values.ccmCampaignPackageLOutfits ?? 12,
      numOutfitsRange: values.ccmCampaignPackageLOutfitsRange ?? '10-12',
      numOutfitClicks: values.ccmCampaignPackageLOutfitClicks ?? 30000,
      numOutfitViews: values.ccmCampaignPackageLOutfitViews ?? 120000,
      numWeeks: values.ccmCampaignPackageLNumWeeks ?? 3
    },
    m: {
      promotionBudget: values.ccmCampaignPackageMBudget ?? 10000,
      numOutfits: values.ccmCampaignPackageMOutfits ?? 8,
      numOutfitsRange: values.ccmCampaignPackageMOutfitsRange ?? '5-8',
      numOutfitClicks: values.ccmCampaignPackageMOutfitClicks ?? 15000,
      numOutfitViews: values.ccmCampaignPackageMOutfitViews ?? 60000,
      numWeeks: values.ccmCampaignPackageMNumWeeks ?? 3
    },
    s: {
      promotionBudget: values.ccmCampaignPackageSBudget ?? 5000,
      numOutfits: values.ccmCampaignPackageSOutfits ?? 4,
      numOutfitsRange: values.ccmCampaignPackageSOutfitsRange ?? '2-4',
      numOutfitClicks: values.ccmCampaignPackageSOutfitClicks ?? 6000,
      numOutfitViews: values.ccmCampaignPackageSOutfitViews ?? 24000,
      numWeeks: values.ccmCampaignPackageSNumWeeks ?? 3
    }
  };
}
